import React from 'react';
import { ChevronUpIcon, ChevronDownIcon, ChevronUpDownIcon } from '@heroicons/react/24/outline';
import { cn } from '../../shared/lib/cn';

interface Props {
  label: string;
  field: string;
  sortBy: string;
  sortDir: string;
  onSort: (field: string) => void;
  align?: 'left' | 'right' | 'center';
  className?: string;
}

export function SortableHeader({ label, field, sortBy, sortDir, onSort, align = 'left', className }: Props) {
  const isActive = sortBy === field;

  return (
    <th
      className={cn(
        'py-2 px-3 font-medium text-gray-500 dark:text-gray-400',
        'cursor-pointer select-none hover:text-gray-700 dark:hover:text-gray-200 transition-colors',
        align === 'right' && 'text-right',
        align === 'center' && 'text-center',
        className,
      )}
      onClick={() => onSort(field)}
    >
      <div className={cn(
        'flex items-center gap-1',
        align === 'right' && 'justify-end',
        align === 'center' && 'justify-center',
      )}>
        <span>{label}</span>
        <span className="flex-shrink-0">
          {isActive ? (
            sortDir === 'ASC' ? (
              <ChevronUpIcon className="w-3.5 h-3.5 text-eliza-red" />
            ) : (
              <ChevronDownIcon className="w-3.5 h-3.5 text-eliza-red" />
            )
          ) : (
            <ChevronUpDownIcon className="w-3.5 h-3.5 opacity-40" />
          )}
        </span>
      </div>
    </th>
  );
}
